import { TPlanUsageInterval } from './PlanUsage.type';

export const barColors = {
  CURRENT: 'var(--color-brand-green1-darker)',
  FORECAST: 'var(--color-brand-green1-lightest)',
  PAST: 'var(--color-brand-orange1-normal)',
};

export const getLineWidth = (
  value: number,
  intervals: TPlanUsageInterval[],
) => {
  const currentInterval = intervals.find((x) => x.max === value) || {
    min: 0,
    max: 0,
  };
  let interval = value;

  if (currentInterval.min > 0) {
    interval = value - currentInterval.min;
  }

  return (interval * 100) / intervals[intervals.length - 1].max + '%';
};

export const getAbsoluteWidth = (value: number, maxValue: number) => {
  return (value * 100) / maxValue + '%';
};

const getIntervalIndex = (value: number, intervals: TPlanUsageInterval[]) => {
  if (value === 0) {
    return 0;
  }

  if (value > intervals[intervals.length - 1].max) {
    return intervals.length - 1;
  }

  return intervals.findIndex((x) => x.min < value && x.max >= value);
};

const flexChartMinIndex = 3;
const flexChartNumberOfPreviousIntervals = 2;
export const getIntervals = (
  intervals: TPlanUsageInterval[],
  forecastUsage: number,
  currentUsage?: number,
) => {
  const indexForecast = getIntervalIndex(forecastUsage, intervals);
  const indexBase = currentUsage
    ? getIntervalIndex(currentUsage, intervals)
    : indexForecast;

  if (indexForecast <= flexChartMinIndex) {
    return intervals.slice(0, 5);
  }

  const newInterval =
    intervals.length >= flexChartMinIndex && indexBase >= flexChartMinIndex
      ? intervals.slice(
          indexBase - flexChartNumberOfPreviousIntervals,
          indexForecast + flexChartNumberOfPreviousIntervals,
        )
      : intervals.slice(0, indexForecast + flexChartNumberOfPreviousIntervals);

  newInterval[0].min = 0;

  return newInterval;
};
